import { TableColumnMeta } from "ds/components/Table/types";

import { ScanResourcesFilterItemKeys } from "../../constants";

export const SCAN_RESOURCES_COLUMNS_STORAGE_KEY = "scanResourcesColumnsConfig";
export const SCAN_RESOURCES_FILTERS_ORDER_KEY = "scanResourcesFiltersOrder";
export const SCAN_RESOURCES_LIMIT = 25;
export const SCAN_RESOURCES_LIMIT_STORAGE_KEY = "scanResourcesLimit";
export const SCAN_RESOURCES_PAGINATION_OPTIONS = [25, 50];

export enum SCAN_RESOURCES_COLUMN_ID {
  NAME = "NAME",
  TYPE = "TYPE",
  STATUS = "STATUS",
  REGION = "REGION",
  SETTINGS = "SETTINGS",
}

const MAX_CELL_WIDTH = 1200;

export const SCAN_RESOURCES_COLUMN_CONFIG: Record<SCAN_RESOURCES_COLUMN_ID, TableColumnMeta> = {
  [SCAN_RESOURCES_COLUMN_ID.NAME]: {
    id: SCAN_RESOURCES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 320,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    configurable: true,
  },
  [SCAN_RESOURCES_COLUMN_ID.TYPE]: {
    id: SCAN_RESOURCES_COLUMN_ID.TYPE,
    title: "Type",
    minWidth: 150,
    defaultWidth: 220,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCAN_RESOURCES_COLUMN_ID.STATUS]: {
    id: SCAN_RESOURCES_COLUMN_ID.STATUS,
    title: "Resource",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: 240,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCAN_RESOURCES_COLUMN_ID.REGION]: {
    id: SCAN_RESOURCES_COLUMN_ID.REGION,
    title: "Region",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: 280,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    configurable: true,
  },
  [SCAN_RESOURCES_COLUMN_ID.SETTINGS]: {
    id: SCAN_RESOURCES_COLUMN_ID.SETTINGS,
    title: "Table settings",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SCAN_RESOURCES_SORT_CONFIG: Partial<Record<SCAN_RESOURCES_COLUMN_ID, string>> = {
  [SCAN_RESOURCES_COLUMN_ID.NAME]: ScanResourcesFilterItemKeys.NAME,
  [SCAN_RESOURCES_COLUMN_ID.TYPE]: ScanResourcesFilterItemKeys.TYPE,
};
